import script from "./QRCodeScanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./QRCodeScanner.vue?vue&type=script&setup=true&lang=ts"

import "./QRCodeScanner.vue?vue&type=style&index=0&id=a88c2b3a&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a88c2b3a"]])

export default __exports__